import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateCompany, UpdateCompany} from "../../types/api/guide/company.types";

export const companyService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.company.getAll),

    create: (company: CreateCompany) =>
        apiCall.post(apiUrls.guide.company.create, company),

    update: (id: string, company: UpdateCompany) =>
        apiCall.put(apiUrls.guide.company.update(id), company),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.company.delete(id)),

    getById: (id: string) =>
        apiCall.get(apiUrls.guide.company.getById(id))
}